import React, { useEffect, useRef, useState } from 'react';

const slidesData = [
  { src: '/img/Car_Imgs/backedIntoGarageWide.jpg', alt: 'Garage Image 1' },
  { src: '/img/Car_Imgs/Lexi_at_Home.jpg', alt: 'Garage Image 2' },
  { src: '/img/Car_Imgs/lexi_Clean.jpg', alt: 'Garage Image 3' },
];

export default function Slideshow({ alwaysShowText = false, text = "" }) {
  const [slideIndex, setSlideIndex] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slidesData.length);
    }, 10000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const setSlide = (idx) => {
    setSlideIndex(idx);
    resetInterval();
  };

  const resetInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slidesData.length);
    }, 10000);
  };

  const nextSlide = () => {
    setSlideIndex((prev) => (prev + 1) % slidesData.length);
    resetInterval();
  };

    return (
      <div className="banner-container" onClick={nextSlide}>
        <div className="banner-text">{text || "Welcome to the Garage!"}</div>
        {slidesData.map((slide, idx) => (
          <div className={`banner-slide${slideIndex === idx ? ' active' : ''}`} key={idx}>
            <img src={slide.src} alt={slide.alt} />
          </div>
        ))}
        <div className="banner-controls">
          {slidesData.map((_, idx) => (
            <div
              key={idx}
              className={`banner-dot${slideIndex === idx ? ' active' : ''}`}
              onClick={(e) => { e.stopPropagation(); setSlide(idx); }}
            ></div>
          ))}
        </div>
      </div>
    );
}
